// Module
var code = `<div class="HOA-Header__wrapper" (click)="closeSubMenu();">
    <header class="HOA-Header">
        <div class="HOA-Header__left-container">
            <!-- WEB CONTENT -->
            <div class="hide-if-platform-size-phone"></div>
        </div>
        <!-- This is the element we have to hide when we don't want the right content -->
        <div class="HOA-Header__right-container" *ngIf="displayRightContent">
            <!-- PHONE SIZE -->
            <div class="hide-if-platform-size-tablet-or-desktop">
                <button
                        class="HOA-Header__hamburger"
                        tid="openSubMenu"
                        (click)="toggleSubMenu(); \$event.stopPropagation();">
                    <span class="HOA-Header__hamburger-and-x-icon"></span>
                </button>
            </div>
            <!-- LARGER THAN PHONE SIZE -->
            <div class="hide-if-platform-size-phone HOA-Header-menu__container">
                <div *ngFor="let item of items"
                     class="HOA-Header-menu__item-wrapper"
                     [class]="{'HOA-Header-menu__item-wrapper--show-left-divider': item.isDropdownWhenWebFull}">
                    <div class="HOA-Header-menu__item">
                        <button
                                type="button"
                                (click)="navToTab(item.section, item.isDropdownWhenWebFull); \$event.stopPropagation();"
                                class="HOA-Header-menu__item-link"
                                [attr.tid]="item.tid + '-header'">
                            <!-- block click events so click don't close the sub-menu -->
                            <span class="HOA-Header-menu__item-pill"
                                  [class.is-active]="item.section === currentSection">
                                        {{item.name}}
                                <span *ngIf="item.isDropdownWhenWebFull"
                                      class="HOA-Header-menu__itemArrow">
                                        </span>
                                    </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="HOA-Header__content">
            <div tid="mutualLogo" class="hide-if-platform-cordova HOA-Header__content-logo"></div>
            <div class="hide-if-platform-web HOA-Header__content-title-wrapper">
                <div #headerContentTitle
                     class="HOA-Header__content-title HOA-Header__cordova-title-container"></div>
            </div>
        </div>
    </header>
</div>

<nav class="HOA-Header-web-nav-menu__wrapper" tid="closeSubMenu" (click)="closeSubMenu();">
    <div class="HOA-Header-web-nav-menu__content" (click)="\$event.stopPropagation();">
        <!-- block click events so click don't close the sub-menu -->
        <app-moo-menu
                [mainNavItems]="mobileNavItems"
                [currentSection]="currentSection"
                (menuChanged)="menuChanged(\$event)">
        </app-moo-menu>
    </div>
</nav>`;
// Exports
module.exports = code;